import React, { useState, useEffect } from "react";
import MdEditor from "react-markdown-editor-lite";
import "react-markdown-editor-lite/lib/index.css";
import mdParser from "../utils/parser"
import { FormControl, Modal, Toast, Button, Card, Form } from "react-bootstrap";
import ImageViewer from "./image_viewer";
import LinkPlugin from "../plugins/link_plugin";
import TocPlugin from "../plugins/toc_plugin";
import useSendPropuesta from "../hooks/use_send_propuesta";

MdEditor.use(LinkPlugin)
MdEditor.use(TocPlugin)

const Editor = ({ articulo, onCancel, onSave }) => {
  const [titulo, setTitulo] = useState("");
  const [motivo, setMotivo] = useState("");
  const [etiquetas, setEtiquetas] = useState("");
  const [relacionados, setRelacionados] = useState("");
  const [contenido, setContenido] = useState("");
  const [aceptado, setAceptado] = useState(false);
  const [anonimo, setAnonimo] = useState(false);
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  const [imagen, setImagen] = useState("");
  const [isNew, setIsNew] = useState(true);

  const { sendPropuesta, isBusy } = useSendPropuesta();

  useEffect(() => {
    setIsNew(articulo ? false : true);
    setTitulo(articulo?.titulo || "");
    setImagen(articulo?.imagen || "");
    setContenido(articulo?.contenido || "");
    setEtiquetas(articulo?.etiquetas?.join(", ").toLowerCase() || "");
    setRelacionados(articulo?.relacionados?.join(", ").toLowerCase() || "");
  }, [articulo]);

  const reestablecer = () => {
    setTitulo(
      articulo && articulo.titulo
        ? articulo.titulo
        : ""
    );
    setContenido(articulo && articulo.contenido ? articulo.contenido : "");
    setEtiquetas(
      articulo && articulo.metadata && articulo.metadata.tags
        ? articulo.metadata.tags.join(", ").toLowerCase()
        : ""
    );
    setRelacionados(
      articulo && articulo.metadata && articulo.metadata.relacionados
        ? articulo.metadata.relacionados.join(", ").toLowerCase()
        : ""
    );
    setMotivo("");
    setAceptado(false);
    onCancel();
  };

  const getFileName = () => {
    return titulo.toLowerCase().replace(/ /g, "-").replace(/,/g, "");
  };

  const onSuccess = () => {
    onCancel();
    if (onSave) onSave();
  };

  const onFail = () => {
    setError(true);
  };

  const sendArticulo = () => {
    const propuesta = {
      titulo,
      motivo,
      contenido,
      etiquetas: etiquetas && etiquetas !== "" ? etiquetas.split(", ") : [],
      relacionados:
        relacionados && relacionados !== "" ? relacionados.split(", ") : [],
      imagen,
    }
    if (articulo?._id) propuesta.articulo = articulo._id;
    sendPropuesta(
      propuesta,
      onSuccess,
      onFail
    );
  };

  const checkIfValidForm = () =>
    motivo &&
    motivo !== "" &&
    contenido &&
    contenido !== "" &&
    titulo &&
    titulo !== "";

  return (
    <div>
      <Form.Check
        type="checkbox"
        value={anonimo}
        onChange={(e) => setAnonimo(!anonimo)}
        label="Edición Anónima (No se agregará tu nombre a la lista de autores del Artículo)"
      />
      {anonimo ? (
        <p style={{ color: "red" }}>
          Nota: Aún si marcas "Anónimo", la propuesta será recibida con tu
          nombre por la administración.
        </p>
      ) : (
          <br />
        )}
      <p>
        Indica, brevemente, el motivo de tu propuesta y/o los principales
        cambios:
      </p>
      <FormControl
        value={motivo}
        onChange={(e) => setMotivo(e.target.value)}
        as="textarea"
        placeholder="Motivo"
        aria-label="motivo"
        className="input-generic"
      />
      <br />
      <p>
        Título del artículo{" "}
        {!isNew && (
          <span style={{ color: "rgb(105, 105, 105)", fontSize: "90%" }}>
            (No modificable)
          </span>
        )}
        :
      </p>
      <FormControl
        value={titulo}
        disabled={!isNew}
        onChange={(e) =>
          setTitulo(e.target.value.replace(/([^A-Za-zñÑáéíóúÁÉÍÓÚüÜ,`\- ])\.*/g, ""))
        }
        placeholder="Título (ej: Mi Artículo)"
        aria-label="título"
        className="input-generic"
      />
      <p>Se podrá acceder a este artículo desde: /articulo/{getFileName()}</p>
      <br />
      <p>
        <span style={{ color: "rgb(105, 105, 105)", fontSize: "90%" }}>
          (Opcional){" "}
        </span>
        URL de Imagen de Cabecera (se recomienda usar{" "}
        <a
          rel="noopener noreferrer"
          target="_blank"
          href="https://imgur.com/upload?beta"
        >
          imgur
        </a>
        ). La imagen debe ser más ancha que alta y se recomienda que tenga al
        menos 1200 pixeles de ancho. Recortar si es necesario:
      </p>
      <FormControl
        value={imagen}
        onChange={(e) => setImagen(e.target.value)}
        placeholder="URL de la Imagen de Cabecera"
        aria-label="imagen de cabecera"
        className="input-generic"
      />
      {imagen && imagen !== "" && (
        <center>
          <div style={{ height: 150 }}>
            <ImageViewer maxHeight={150} imgs={[{ src: imagen }]} />
          </div>
        </center>
      )}
      <br />
      <p>
        <span style={{ color: "rgb(105, 105, 105)", fontSize: "90%" }}>
          (Opcional){" "}
        </span>
        Etiquetas del artículo, separadas por coma y espacio (ej: etiqueta
        <strong>,</strong> etiqueta...):
      </p>
      <FormControl
        value={etiquetas}
        onChange={(e) =>
          setEtiquetas(e.target.value.replace(/([^a-záéíóú,\- ])\.*/g, ""))
        }
        placeholder="Etiquetas (ej: Etiqueta1, Etiqueta2...)"
        aria-label="etiquetas"
        className="input-generic"
      />
      <br />
      <p>
        <span style={{ color: "rgb(105, 105, 105)", fontSize: "90%" }}>
          (Opcional){" "}
        </span>
        Artículos relacionados, separados por coma y espacio (ej: artículo
        <strong>,</strong> artículo...):
      </p>
      <FormControl
        value={relacionados}
        onChange={(e) =>
          setRelacionados(e.target.value.replace(/([^a-záéíóú,\- ])\.*/g, ""))
        }
        placeholder="Artículos Relacionados (ej: artículo, artículo...)"
        aria-label="artículos"
        className="input-generic"
      />
      <br />
      <p>
        Contenido del artículo, usando la sintaxis{" "}
        <a
          href="https://markdown.es/sintaxis-markdown/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Markdown
        </a>{" "}
        (la misma que se usa para blogs):
      </p>
      <div style={{ height: 600 }}>
        <MdEditor
          plugins={[
            "header",
            "fonts",
            "table",
            "image",
            "custom-link",
            "add-toc",
            "clear",
            "logger",
            "mode-toggle",
            "full-screen",
          ]}
          value={contenido}
          htmlClass="html_parser editor_md"
          renderHTML={(text) => mdParser.parse(text)}
          onChange={({ html, text }) => setContenido(text)}
          onCustomImageUpload={() => {
            return new Promise((resolve, reject) => {
              const result = window.prompt(
                "Ingrese la URL de la imagen a agregar"
              );
              resolve({ url: result });
            });
          }}
          config={{
            markdownClass: "html_parser editor_md",
          }}
        />
      </div>
      <br />
      <p>Acepta las siguientes condiciones:</p>
      <Card>
        <Card.Body>
          <Card.Title>Condiciones</Card.Title>
          <p>
            El contenido propuesto debe ser creación original o estar basado en
            material público y sin derechos de autor que restrinjan su copia. No
            se permite material que sea plagio de franquicias.
          </p>
          <p>
            El autor cede todos los derechos de manera irrevocable al foro al
            enviar a revisión. El foro puede usar, archivar, editar, derivar,
            expandir y publicar el material según el Staff lo estime
            conveniente.
          </p>
        </Card.Body>
      </Card>
      <div style={{ textAlign: "center", marginTop: 32 }}>
        <Form.Check
          type="checkbox"
          value={aceptado}
          onChange={(e) => setAceptado(!aceptado)}
          label="Acepto estas condiciones"
        />
        <br />
        <Button onClick={() => reestablecer()}>
          <i className="fas fa-times"></i> Cancelar
        </Button>{" "}
        <Button
          disabled={!aceptado || !checkIfValidForm()}
          variant="success"
          onClick={() => {
            // sendArticulo();
            setShow(true);
          }}
        >
          <i className="fas fa-save"></i> Enviar para Revisión
        </Button>
        <br />
        <br />
        <p>
          Nota: El Staff está formado por gente voluntaria que dedica su tiempo
          a ayudar a que todos tengamos una buena experiencia de roleo. Es
          normal que los procesos de revisión tarden.
        </p>
        <p>
          Aerandir tiene un lore propio y es tarea del Staff preservarlo. Nos
          reservamos el derecho de rechazar propuestas sin tener que dar
          explicaciones.
        </p>
      </div>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Enviar Propuesta</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Estás seguro de que deseas enviar esta propuesta de artículo a
          revisión?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Cancelar
          </Button>
          <Button
            disabled={isBusy}
            variant="success"
            onClick={sendArticulo}
          >
            Sí, Enviar
          </Button>
        </Modal.Footer>
      </Modal>
      <Toast
        style={{ position: "absolute", top: 5, right: 5 }}
        onClose={() => setError(false)}
        show={error}
        delay={5000}
        autohide
      >
        <Toast.Header>
          <strong className="mr-auto">¡Ocurrió un error!</strong>
        </Toast.Header>
        <Toast.Body>
          No hemos podido contactar al servidor. Intenta de nuevo más tarde.
        </Toast.Body>
      </Toast>
      <br />
    </div>
  );
};

export default Editor;
